<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.video-section {
    position: relative;

    .video-thumbnail {
        cursor: pointer;

        .play-button {
            position: absolute;
            z-index: 5;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            .icon {
                display: block;
                flex-shrink: 0;
                width: 80px;
                height: 80px;
                margin: 0 auto 1.25rem auto;
                @apply bg-white bg-opacity-30;
                border-radius: 50%;
                position: relative;
                transition: border-color 0.15s;

                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    box-sizing: border-box;
                    width: 28px;
                    height: 32px;
                    border-width: 16px 0px 16px 28px;
                    border-style: solid;
                    border-color: transparent transparent transparent #fff;
                    transition: border-color 0.15s;
                }
            }
        }

        &:hover {
            .play-button {
                .icon {
                    border-color: $primary;

                    .play {
                        border-color: transparent transparent transparent $primary;
                    }
                }
            }
        }
    }
}
</style>

<template>
    <div class="video-section flex-1 relative">
        <div v-if="videoId != null && videoId != ''" class="video-thumbnail" @click="$root.videoModalVisible = videoId">
            <img v-if="videoThumbnail" class="lazyload inset-0 h-full w-full object-cover object-center absolute" :data-src="videoThumbnail" :alt="buttonText" />
            <img v-else class="lazyload inset-0 w-full object-cover object-center absolute h-full" :data-src="`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`" :alt="buttonText" />
            <div class="bg-primary pointer-events-none absolute inset-0 h-full w-full bg-opacity-50"></div>

            <div class="play-button">
                <span class="icon">
                    <span class="play"></span>
                </span>
                <span class="text-white block w-full px-[10%] text-18 font-extrabold">{{ buttonText }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        large: {
            type: Boolean,
            required: false,
        },
        videoId: {
            type: String,
            required: false,
        },
        videoThumbnail: {
            type: String,
            required: false,
        },
        buttonText: {
            type: String,
            required: false,
        },
    },
};
</script>
